import { FunctionComponent } from "react";

import dynamic from "next/dynamic";

import { DevContextCopyProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
export const DevContextCopy = dynamic(() => import("./DevContextCopySsr").then((mod) => mod.DevContextCopySsr), {
  ssr: false,
}) as FunctionComponent<DevContextCopyProps>;
